import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AdxBookingVccJoinModel} from '../model/adx-booking-vcc-join-model';

@Injectable({
  providedIn: 'root'
})
export class BookingVirtualCreditCardService {
  private resourcePath: string = 'dbov2/adx-booking-virtual-credit-card';

  constructor(private httpClient: HttpClient) {
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || 'server Error');
  }

  public getAdxBookingVirtualCreditCardQuery(adxBookingId: number): Observable<AdxBookingVccJoinModel[]> {
    let httpParams = new HttpParams({fromObject: { adxBookingId: adxBookingId}});
    return this.httpClient
      .get<AdxBookingVccJoinModel[]>(this.resourcePath, {params: httpParams})
      .pipe(catchError(this.errorHandler));
  }
}
